import {useEffect,useRef,useState} from 'react';
import '../styles/tv.css';

export default function TrwinTvPage({onBack,embedded}:{onBack:()=>void;embedded:boolean}){
 const[revision,setRevision]=useState(0),heading=useRef<HTMLHeadingElement>(null);
 useEffect(()=>{heading.current?.focus({preventScroll:true});},[]);
 return <main className="tv-page" data-embedded={embedded}>
  <header className="tv-toolbar">
   <button type="button" className="tv-back" onClick={onBack}><span aria-hidden="true">←</span> TRWIN Extra</button>
   <h1 ref={heading} tabIndex={-1}>TRWIN TV</h1>
   <button type="button" className="tv-refresh" onClick={()=>setRevision(value=>value+1)}><span aria-hidden="true">↻</span> Yayını yenile</button>
  </header>
  <div className="tv-player-wrap"><iframe key={revision} src="https://zuwin.live/embed/trwin" title="TRWIN TV" className="tv-player" width="100%" height="720" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen referrerPolicy="strict-origin"/></div>
 </main>;
}
